import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, Card, StatusPill } from "../components/primitives";

export default function Integrations() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/integrations").then(r => setItems(r.data.integrations || [])); }, []);
  return (
    <div>
      <PageHeader title="Integration Hub" subtitle={`${items.length} external connections · live status`} sections={["5.10"]} />
      <div className="p-6">
        <div className="grid grid-cols-3 gap-3">
          {items.map((it) => (
            <Card key={it.name}>
              <div className="p-4">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <div className="text-[13px] font-medium">{it.name}</div>
                    <div className="text-[10px] text-ink-subtle">{it.protocol}</div>
                  </div>
                  <StatusPill status={it.status} />
                </div>
                <div className="text-[11px] text-ink-muted mb-3">{it.purpose}</div>
                <div className="text-[11px] space-y-1 border-t border-line pt-2">
                  <div className="flex justify-between"><span className="text-ink-subtle">Last call</span><span>{it.last_call}</span></div>
                  <div className="flex justify-between"><span className="text-ink-subtle">Latency p95</span><span className="tabular">{it.latency_p95}</span></div>
                  <div className="flex justify-between"><span className="text-ink-subtle">Calls / min</span><span className="tabular">{it.calls_min}</span></div>
                  <div className="flex justify-between"><span className="text-ink-subtle">Auth</span><span>{it.auth}</span></div>
                </div>
                <div className="text-[10px] text-ink-subtle hash-mono mt-2 truncate">{it.endpoint}</div>
              </div>
            </Card>
          ))}
        </div>
        <div className="mt-6 text-[11px] text-ink-subtle italic">
          Connectors shown are configured against representative bank schemas; production deployment configures against the specific institution's core banking, identity, and reporting systems during Phase 3 of the engagement.
        </div>
      </div>
    </div>
  );
}
